// extracted by mini-css-extract-plugin
export default {"container":"LogReg_container__Y+oat","logo":"LogReg_logo__sTqql","loginWrapper":"LogReg_loginWrapper__5BVBz","registerWrapper":"LogReg_registerWrapper__oNUiC"};